import { FeatureFlag } from '../../gamma-api';
import { defaultApi } from '../apis';

// TODO: add other flag types.

export const getFeatureFlags = async (): Promise<FeatureFlag[]> => {
  try {
    const response = await defaultApi.getFeatureFlagsFeatureManagementGet();
    return response.data;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Error while loading feature flags.', e);
    throw e;
  }
};
